import {
	Users,
	LineChart,
	Brain,
	Rocket,
	FileSpreadsheet,
	Puzzle,
	ClipboardList,
	ClipboardCheck,
	GitBranch,
	Calendar,
	Calculator,
	Code,
	TestTube,
	BookOpen,
	LifeBuoy,
	BarChart,
	UserCog,
	Database,
	Wrench,
} from 'lucide-react';

export const process = [
	{
		title: 'Start With a Free Diagnostic',
		description:
			"Before any commitment, get a clear read on where your systems stand today — through a quick assessment, an ROI estimate, or a conversation.",
		icon: Rocket,
		modalDetails: [
			{
				title: 'Schedule a Discovery Session',
				description:
					"Prefer to talk it through? Book a 1:1 consult and I'll help map out what makes sense for your business.",
				icon: Brain,
			},
			{
				title: 'Take the Tech Assessment',
				description:
					'16 quick questions across data, automation, reporting, and security — get a scored readout in minutes.',
				icon: ClipboardCheck,
				link: {
					text: 'Take the free assessment',
					href: '/tools/tech-audit-assessment',
				},
			},
			{
				title: 'Try the ROI Calculator',
				description:
					'See what manual, repetitive work is costing you every year — and what automating it could save.',
				icon: Calculator,
				link: {
					text: 'Calculate my ROI',
					href: '/tools/automation-roi-calculator',
				},
			},
			{
				title: 'Flexible by Design',
				description:
					"Already have systems in place? We'll focus on the gaps, not force you into a rigid package.",
				icon: Puzzle,
			},
		],
	},
	{
		title: 'Get Your Roadmap & Proposal',
		description:
			"We'll map the workflows, tools, and data flows you need across the Four Pillars — then translate that into a clear, flexible scope.",
		icon: ClipboardList,
		modalDetails: [
			{
				title: 'Collaborative Planning',
				description:
					"Together, we'll define your must-haves, nice-to-haves, and the gaps in your current systems.",
				icon: Users,
			},
			{
				title: 'Workflow & Tech Mapping',
				description:
					'Map out how your internal tools, data, and automations should connect across the Four Pillars.',
				icon: GitBranch,
			},
			{
				title: 'Scope & Cadence',
				description: 'Set a monthly cadence and priorities so we always know what comes next.',
				icon: Calendar,
			},
			{
				title: 'Clear Scope, No Surprises',
				description:
					"You'll receive a straightforward proposal that reflects real priorities, not padded scope.",
				icon: FileSpreadsheet,
			},
		],
	},
	{
		title: 'Ongoing Build & Support',
		description:
			"As your fractional CTO, I personally build and maintain your apps, automations, and dashboards — solving real problems, month after month, not shipping a one-off project.",
		icon: Code,
		modalDetails: [
			{
				title: 'Custom Development',
				description:
					'Power Apps, dashboards, workflows, SQL databases, and integrations — built to spec, not out-of-the-box.',
				icon: Database,
			},
			{
				title: 'Testing & Review Cycles',
				description:
					"I test everything before handoff — and we iterate together to ensure it's truly useful.",
				icon: TestTube,
			},
			{
				title: 'Training & Documentation',
				description:
					"You'll receive how-to docs, recordings, or live walkthroughs based on what your team needs.",
				icon: BookOpen,
			},
			{
				title: 'Continuous Support',
				description:
					'Support, iteration, and small updates are already part of the engagement — no re-scoping needed.',
				icon: LifeBuoy,
			},
		],
	},
	{
		title: 'Grow the Partnership',
		description:
			"With ongoing support, strategy, and reporting, I stay in your corner as your tech — and your partnership — evolves alongside your business.",
		icon: UserCog,
		modalDetails: [
			{
				title: 'Monthly Strategy Check-Ins',
				description:
					'Plan your next steps, review roadmaps, and realign tech to your evolving goals.',
				icon: BarChart,
			},
			{
				title: 'Dashboards & Reporting Support',
				description: 'Get help with recurring reports, insights, and keeping your data useful.',
				icon: LineChart,
			},
			{
				title: 'Fractional CTO & Analyst Support',
				description:
					'Need a fractional tech lead or ongoing data analyst? I offer flexible engagement tiers to support your growth.',
				icon: UserCog,
			},
			{
				title: 'Mini Builds & Updates',
				description: 'Add a new form, tweak a dashboard, or request a small automation anytime.',
				icon: Wrench,
			},
		],
	},
];
